// RoleContext.js
import React, { createContext, useContext, useEffect, useState } from "react";
import { useOidcUser } from "@axa-fr/react-oidc";

const RoleContext = createContext();

export const RoleProvider = ({ children }) => {
  const { oidcUser } = useOidcUser();
  const [roles, setRoles] = useState([]);

  useEffect(() => {
    if (oidcUser?.role) {
      const userRoles = Array.isArray(oidcUser.role) ? oidcUser.role : [oidcUser.role];
      const userDataToStore = {
        given_name: oidcUser.given_name,
        email: oidcUser.email,
      };
      setRoles(userRoles);
      localStorage.setItem("userRoles", JSON.stringify(userRoles));
      localStorage.setItem("oidcUserData", JSON.stringify(userDataToStore));
    }
  }, [oidcUser]);

  useEffect(() => {
    const cachedRoles = localStorage.getItem("userRoles");
    if (cachedRoles && roles.length === 0) {
      setRoles(JSON.parse(cachedRoles));
    }
  }, []);

  return <RoleContext.Provider value={roles}>{children}</RoleContext.Provider>;
};

export const useRoles = () => useContext(RoleContext);
